<template>
    <div class="row my-4 teacher-item-horizontal" @click="authorClick(author, $event)">
        <div class="col-lg-4 col-12 text-lg-left text-center">
            <img class="teacher-item-foto-horizontal" :src="`${author.photo}`" :alt="author.author">
        </div>
        <div class="col-lg-8 col-12 text-center">
            <div class="teacher-item-name-horizontal">{{ author.author }}</div>
            <div class="teacher-description-horizontal">{{ descriptionTrancated }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AuthorGalleryItemHorisontal",

        props: {
            author: Object
        },

        computed: {
            descriptionTrancated() {
                return this.truncateString(this.author.description, 512);
            },
        },

        methods: {
            authorClick(author, event) {
                console.log('click AutorGalleryItem author', author)
                this.$emit('authorClick', author, event)
            },

            truncateString(str, num) {
                // If the length of str is less than or equal to num
                // just return str--don't truncate it.
                if (str.length <= num) {
                    return str
                }
                // Return str truncated with '...' concatenated to the end of str.
                return str.slice(0, num) + '...'
            }
        }

    }
</script>

<style>
    .teacher-item-horizontal {
        cursor: pointer;
    }

    .teacher-item-name-horizontal {
        display: block;
        font-size: 18px;
        font-family: Manrope Bold;
        color: #231c37;
        margin-bottom: 15px;
        text-decoration: underline;
        margin-top: 9px;
        text-align: center;
    }

    .teacher-description-horizontal {
        font-size: 13px;
        line-height: 15px;
    }

    .teacher-description-horizontal:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(transparent 60%, white);
    }


    .teacher-item-foto-horizontal {
        border-radius: 50%;
        box-shadow: 1px 2px 7px 1px rgba(40, 40, 40, 0.5);
        margin-bottom: 15px;
        width: 190px;
        height: 190px;
        object-fit: cover;
        max-width: 100%;
    }

</style>
